import React from 'react';

const ErrorPage = () => {
    return (
        <div>
            Page not foound
        </div>
    );
};

export default ErrorPage;